export const STATUSES = {
  // Draft/Initial states
  draft: {
    label: "Draft",
    className: "text-ember-900 border-ember-200 bg-ember-50",
  },

  // Project states
  active: {
    label: "Active",
    className: "bg-green-50 border-green-200 text-green-900",
  },
  inactive: {
    label: "Inactive",
    className: "bg-red-50 border-red-200 text-red-900",
  },

  // Work flow states
  backlog: {
    label: "Backlog",
    className: "text-red-900 border-red-200 bg-red-50",
  },
  todo: {
    label: "Todo",
    className: "text-blue-900 border-blue-200 bg-blue-50",
  },
  in_progress: {
    label: "In Progress",
    className: "text-yellow-900 border-yellow-200 bg-yellow-50",
  },
  in_review: {
    label: "In Review",
    className: "text-orange-900 border-orange-200 bg-orange-50",
  },

  // Billing/Collection states
  contracted: {
    label: "Contracted",
    className: "text-red-900 border-red-200 bg-red-50",
  },
  pending_invoice: {
    label: "Pending Invoice",
    className: "text-yellow-900 border-yellow-200 bg-yellow-50",
  },
  billed: {
    label: "Billed",
    className: "text-blue-900 border-blue-200 bg-blue-50",
  },
  collected: {
    label: "Collected",
    className: "text-green-900 border-green-200 bg-green-50",
  },

  // Final states
  closed: {
    label: "Closed",
    className: "text-green-900 border-green-200 bg-green-50",
  },
  archived: {
    label: "Archived",
    className: "text-gray-900 border-gray-200 bg-gray-50",
  },
  cancelled: {
    label: "Cancelled",
    className: "text-orange-900 border-orange-200 bg-orange-50",
  },

  // Pull Request states
  pending: {
    label: "Pending",
    className: "text-yellow-900 border-yellow-200 bg-yellow-50",
  },
  open: {
    label: "Open",
    className: "text-blue-900 border-blue-200 bg-blue-50",
  },
  merged: {
    label: "Merged",
    className: "text-purple-900 border-purple-200 bg-purple-50",
  },

  // tickets
  on_hold: {
    label: "On Hold",
    className: "text-orange-900 border-orange-200 bg-orange-50",
  },
  resolved: {
    label: "Resolved",
    className: "text-green-900 border-green-200 bg-green-50",
  },

  //casestudy
  draft: {
    label: "Draft",
    className: "text-gray-700 border-gray-300 bg-gray-100",
  },
  submitted: {
    label: "Submitted",
    className: "text-blue-800 border-blue-200 bg-blue-50",
  },
  completed: {
    label: "Completed",
    className: "text-green-900 border-green-200 bg-green-50",
  },
  published: {
    label: "Published",
    className: "text-purple-900 border-purple-200 bg-purple-50",
  },

  approved: {
    label: "Approved",
    className: "text-green-900 border-green-200 bg-green-50",

  }
};